import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'
import { SectionHeading } from '../../Styles/style'

import arrow from "../../../assets/images/arrow.png"
const SectionWrapper = styled.div`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
place-content: center;
flex-direction: column;
align-items: center;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    /* padding: ${(props) => (props.p799 ? props.p799 : "30px 0")}; */
  }
  @media screen and (max-width: 599px) {
    /* padding: ${(props) => (props.p599 ? props.p599 : "30px 0")}; */
  }
`;
const ConnectButt = styled.a`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
align-items: center;
text-align: center;
place-content: center;
margin: ${(props) => (props.m ? props.m : "")};
padding: ${(props) => (props.p ? props.p : "11px 30px")};
font-family: "Poppins-Medium";
font-size: 15px;
color: ${(props) => props.theme.textPrimary};
text-decoration:none ;
cursor: pointer;
border: 1px solid ${(props) => (props.border ? props.border : props.theme.textPriamry)};
@media screen and (max-width:599px){
  /* padding: ${(props) => (props.p ? props.p : "7px 10px")}; */
  /* max-width: ${(props) => (props.mw ? props.mw : "50%")}; */

}
`
const BtnDIv = styled.div`
display: flex;
align-items:center ;
gap: 3px;
padding: 40px 0;
@media screen and (max-width:699px){

  display: inline-grid;
}
`
const OpenSource = (props) => {
  const theme = useTheme();
  return (
    <div>
      <SectionWrapper p="6rem 1rem" bgcolor={theme.bgSecondary}>
        <SectionHeading align="center" color={theme.textSecondary} data-aos="zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="1000">Open Source And Secured By Audits.</SectionHeading>
        <BtnDIv>
          <ConnectButt target="blank" href={props.link1st} bgcolor={props.bgcolor1st} data-aos="zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-offset="0"
            data-aos-duration="1000">{props.heading1st} &nbsp;<img src={arrow} /></ConnectButt>
          <ConnectButt target="blank" href={props.link2nd} bgcolor={props.bgcolor2nd} data-aos="zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="600"
            data-aos-offset="0"
            data-aos-duration="1000">{props.heading2nd} &nbsp;<img src={arrow} /></ConnectButt>
          <ConnectButt target="blank" href={props.link3rd} bgcolor={props.bgcolor3rd} data-aos="zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="800"
            data-aos-offset="0"
            data-aos-duration="1000">{props.heading3rd} &nbsp;<img src={arrow} /></ConnectButt>
        </BtnDIv>

      </SectionWrapper>
    </div>
  )
}

export default OpenSource